module.exports = __webpack_public_path__ + "static/media/about_white.fb153850.png";